<template>
  <v-container>
    <v-card>
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold"> Firmar {{ formTitle }}</h2>
        <v-spacer></v-spacer>
        <!-- <v-btn color="#0A4A79" dark to="/panel" small> -->
        <v-btn color="#0A4A79" class="mr-1" dark to="/escritos/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <v-btn color="#0A4A79" dark to="/escritos/show" small class="ml-3">
          <v-icon small class="mr-5">mdi-file</v-icon>
          Ir al Escrito
        </v-btn>
      </v-card-title>
      <v-card-text>
        <h3> <b>{{roleUser.toUpperCase()}}:</b> {{currentUser.nombre + ' ' +currentUser.primer_apellido+ ' ' +currentUser.segundo_apellido}}</h3>
      </v-card-text>
      <v-divider inset></v-divider>
      <v-card-text style="color: grey" class="font-weight-black">
        <v-row class="mb-n5">
          <v-col cols="12" md="6">
            <div v-if="currentOrden.sala_id < 12">
              <h4 v-if="currentOrden.numero_completo != 0"><span style="color: darkslategrey">NUM. DE TOCA: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE TOCA: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <div  v-if="currentOrden.sala_id == 12">
              <h4 v-if="currentOrden.numero_completo != 0 || currentOrden.sala_id == 12"><span style="color: darkslategrey">NUM. DE ASUNTO: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE ASUNTO: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <span class="font-weight-small  mr-3" style="color: #225882">ESTATUS:</span>
                      <u v-if="currentOrden.status==2" style="color: green">Registrada</u>
                      <u v-if="currentOrden.status==3" style="color: green">Contestada</u><br>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <span v-if="!currentOrden.secretario_id" class="font-weight-small black--text mr-3">Abogado:</span>
            <span v-else-if="currentOrden.secretario_id" class="font-weight-small black--text mr-3">Secretario:</span>
              <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado }}</u>
              <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario }}</u><br>
            <span class="font-weight-small black--text mr-3">Email:</span>
              <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado_email }}</u>
              <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario_email }}</u><br>
            <span class="font-weight-small black--text mr-3">Fecha de envío:</span><u>{{currentOrden.created_at | formatDate}}</u><br>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <!-- <v-row>
            <v-col v-if="currentOrden.tipo == 2" cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Para Firmar Contestación a la presentación de la Promoción</h3>
            </v-col>
          </v-row>
          <br> -->

          <!-- <v-card> -->
            <template>
              <v-container>
              <v-card
                class="mx-auto"
              >
                <v-list shaped>
                  <v-subheader><h2>Firmantes de {{formTitle}}</h2>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue darken-3" dark @click="getFile()">
                      <v-icon small left>mdi-file-document</v-icon>
                      ver {{formTitle}}
                    </v-btn>
                    <!-- <v-btn
                      v-if=""
                      class="ml-1"
                      dark small
                      color="indigo"
                      @click="showToca()">
                        <v-icon small dark left>mdi-folder</v-icon>
                      Ver Historial
                    </v-btn> -->
                  </v-subheader>
                  <v-list
                    multiple
                  >
                    <template v-for="(item, i) in firmasList">
                      <v-divider></v-divider>

                      <v-list-item>
                        <v-list-item-avatar color="#AF8936">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                          <v-list-item-content>
                            <h3 v-if="item.magistrado.segundo_apellido">
                              {{item.magistrado.nombre+' '+item.magistrado.primer_apellido+' '+item.magistrado.segundo_apellido}}
                            </h3>
                            <h3 v-else>{{item.magistrado.nombre+' '+item.magistrado.primer_apellido}}
                            </h3>
                            <h3 v-if="item.firmado == 1">Firmado
                              <v-icon color="green">
                                mdi-file-check
                              </v-icon>
                            </h3>
                            <h3 v-else>Pendiente de Firma
                              <v-icon color="red">
                                mdi-file-remove
                              </v-icon>
                            </h3>
                          </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-list>
              </v-card>
              </v-container>
            </template>

            <v-container v-for="(item, i) in firmasList">
              <!-- <template v-for="(item, i) in firmasList">
                <v-divider></v-divider>
              </template> -->
            <v-card
              class="mx-auto"
              v-if="currentUser.id == item.magistrado_id && item.firmado == 0"
            >
            <v-row>
              <v-col cols="12" md="9">
                <v-row class="">
                  <v-col cols="12">
                    <p v-if="currentUser.segundo_apellido" class="font-weight-black" align="center">Se dispone a Firmar {{formTitle}} el
                      {{currentUser.nombre+' '+currentUser.primer_apellido+' '+currentUser.segundo_apellido}}
                    </p>
                    <p v-else class="font-weight-black" align="center">Se dispone a Firmar {{formTitle}} el
                      {{currentUser.nombre+' '+currentUser.primer_apellido+' '}}
                    </p>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-3">
                  <v-col cols="12" md="10" align="">
                    <v-file-input
                      v-model="file_firel"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      multiple
                      show-size
                      accept=".pfx"
                      @change="SeleccionarPfx($event)"
                      truncate-length="50"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-3">
                  <v-col cols="12" md="10">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-row class="">
                      <v-col cols="2">
                        <v-btn
                          :loading="loading"
                          :disabled="!activarBoton"
                          @click="AgregarFirmante()"
                          color="primary">FIRMAR
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-col>

            </v-row>
          </v-card>

          <v-card
            class="mx-auto"
            v-else-if="currentUser.id == item.magistrado_id && item.firmado == 1"
          >
          <v-alert
            border="top"
            colored-border
            type="success"
            elevation="2"
          >
          <v-row class="">
            <v-col cols="12" md="10">
              <b>{{formTitle}} ya ha sido firmado!</b>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn color="#0A4A79" dark to="/escritos/panel" small>
                <v-icon small class="mr-5">mdi-arrow-left</v-icon>
                Ir a Panel
              </v-btn>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          </v-alert>
        </v-card>
        </v-container><br>

          <!-- </v-card><br> -->
        </v-form>

        <!-- <v-row justify="space-around">
          <v-col cols="auto">
           <v-dialog
             v-model="dialog"
             max-width="70%"
           >
             <template>
               <v-card>
                 <v-form @submit.prevent="saveJuez" ref="form" v-model="valid" lazy-validation>
                 <v-toolbar
                   color="grey darken-2"
                   dense
                   dark
                 >Registro del Toca
                 <v-spacer></v-spacer>
                   <v-btn
                     dark
                     text
                     @click="dialog = false"
                   >
                     Cerrar
                      <v-icon>mdi-close</v-icon>
                   </v-btn>
               </v-toolbar>
                <v-data-table
                  align="left"
                  :loading="loadingTable"
                  :headers="headersToca"
                  :items="listTocas"
                  item-key="id"
                  :page.sync="page"
                  :items-per-page="per_page_table"
                  hide-default-footer
                  no-data-text="No se Encontraron Registros"
                  @page-count="pageCount = $event"
                >
                <template v-slot:item.status="{ item }">
                  <td v-if="item.status == 2" >Registrada</td>
                  <td v-if="item.status == 3" >Contestada</td>
                </template>

                <template  v-slot:item.fechas="{ item }" >
                  <td>
                    <span v-if="item.fecha_contestacion">Contestación: {{item.fecha_contestacion | formatDate}}</span>
                    <br v-if="item.fecha_contestacion">
                    <span>Registrada: {{item.created_at | formatDate}} {{ }}</span>
                  </td>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn class=""  dark x-small color="green" @click="showPromocion()">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver promoción
                  </v-btn>
                </template>

              </v-data-table>
              <div class="text-center pt-2">
                <v-pagination
                  v-if="pagination.total > 1"
                  v-model="pagination.current"
                  :length="pagination.total"
                  :total-visible="7"
                  @input="onPageChange"
                  color="blue"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                ></v-pagination>
              </div>
              </v-form>
               </v-card>
             </template>
           </v-dialog>
         </v-col>
       </v-row> -->

      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { handleUploadMagistrado, _Keys, AddSigner } from '@/services/multifirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        listTocas: [],
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        per_page_table: 1,
        pagination: {
          current: 1,
          total: 0
        },
        dialog:false,
        loading: false,
        valid: true,
        showpass: false,
        activarBoton: false,
        loadingTable: false,
        progress: false,
        currentOrden:'',
        files:[],
        file:[],
        file_firel: [],
        // url_multifirma:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        sign:true,
        // user:'',
        password:'',
        headersToca: [
          { text: 'Toca', value: 'numero_completo' },
          { text: 'Área', value: 'sala_nombre' },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Registro de fechas', value: 'fechas' },
          { text: 'Acciones', value: 'acciones', sortable: false }
        ],
        // MagistradosList: [
        //   { id: 17, nombre: 'Mgdo. Tomás Aguilar Robles' },
        //   { id: 18, nombre: 'Mgdo. José Luis Álvarez Pulido'},
        //   { id: 3, nombre: 'Mgdo. Espartaco Cedeño Muñoz'},
        // ],
        fileRules: [
          // value => !value || value.size < 10000000 || 'Selecciona un Archivo de máximo 10 MB!',
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      formTitle () {
        if (this.currentOrden.sala_id === 12) {
          return 'Asunto Laboral'
        } else if (this.currentOrden.sala_id === 13) {
          return 'Buzón Presidencia'
        } else if (this.currentOrden.fecha_sentencia) {
          return 'Sentencia'
        } else if (this.currentOrden.fecha_amparo) {
          return 'Amparo'
        } else if (this.roleUser == "magistrado") {
          return 'Acuerdo'
        }
        return 'Promoción'
      },
      ...mapGetters(["currentUser", "firmasList", "roleUser"]),
    },
    mounted() {
      this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
      this.getFirmas();
    },
    methods:{
      SeleccionarPfx(filePFX) {
        if (filePFX.length) {
          handleUploadMagistrado(filePFX).then((isValidFile) => {
            if (isValidFile) {
              // console.log('Archivo PFX cargado');
              // console.log(_Keys);
              this.activarBoton = true
            }
          });
        }
      },
      AgregarFirmante() {
          if (this.password) {
              AddSigner(this.password).then((isValid) => {
                if (isValid) {
                  var url = "/multifirma/"+ this.currentOrden.id +"/magistrado/"+ this.currentUser.id
                  if (this.currentOrden.fecha_sentencia) {
                    url = "/sentencia/"+ this.currentOrden.id +"/magistrado/"+ this.currentUser.id
                  }
                  if (this.currentOrden.fecha_amparo) {
                    url = "/amparo/"+ this.currentOrden.id +"/magistrado/"+ this.currentUser.id
                  }
                  this.loading = true;
                  this.password = "";
                  this.file_firel = [];
                  this.Keys = _Keys;
                  const firma = {
                    firma: this.Keys[0]
                  }
                  this.$store.dispatch("SAVE_FIRMA_MAGISTRADO",  { url: url, data: firma})
                    .then(response => {
                      // console.log(response.data);
                      Swal.fire({
                        icon: 'success',
                        title: 'Firmado con Éxito',
                        confirmButtonText: "Aceptar",
                        timer: 1500,
                      })
                      this.loading = false;
                      this.getFirmas()
                      if (this.currentOrden.fecha_sentencia || this.currentOrden.fecha_amparo) {
                        this.$router.push('/escritos/panel')
                      } else {
                        this.$router.push('/panel')
                      }
                  })
                  .catch(error => {
                    console.log(error);
                  });
                  // console.log('AddSigner',_Keys);
                } else {
                  this.password = "";
                  this.file_firel = [];
                  this.activarBoton = false
                  Swal.fire({
                    icon: 'warning',
                    title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                    // showConfirmButton: false,
                    confirmButtonText: "Aceptar",
                    // timer: 1500
                  })
                }
              });
          }
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Ingrese su contraseña',
              showConfirmButton: false,
              timer: 1500
            })
            // alert("Ingrese su contraseña");
          }
      },
      // showToca() {
      //   //this.loadingTable = true;
      //   this.dialog = true
      //   this.$store.dispatch("GET_PROMOCIONES", {
      //     url:"/toca/"+this.currentOrden.id+"/promociones?page="+this.pagination.current,
      //     params: {
      //       // tipo:this.tipo,
      //       // status:this.status,
      //       // sala_id:this.sala_id,
      //       // no_toca:item.numero_completo
      //     }
      //   } )
      //   .then((response) => {
      //     //this.loadingTable = false
      //     this.pagination.current = response.data.data.promociones.current_page;
      //     this.pagination.total = response.data.data.promociones.last_page;
      //     this.per_page_table = response.data.data.promociones.per_page;
      //     this.listTocas = response.data.data.promociones.data;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //     // this.showAlert = true
      //     // this.showTabla = false
      //   });
      // },
      // showPromocion(){
      //   this.$store.dispatch("SHOW_PROMOCION", {
      //     url:"/promocion/"+ this.currentOrden.id,
      //   } )
      //   .then((response) => {
      //   this.$router.push('/escritos/show' )
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
      getFile(){
        var url = "/promocion/"+ this.currentOrden.id +"/previo-multifirma"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/file"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/file"
        }
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: url }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          })
          .catch(err => {
            console.log(err);
            this.progress = false
          });
      },

      getFirmas() {
        var url = "/multifirma/"+ this.currentOrden.id +"/firmas"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/firmas"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/firmas"
        }
        this.$store.dispatch("GET_FIRMAS",  { url: url })
          .then(response => {
            // console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      },

    }
  }
</script>
